import * as VirtualPageEvent from '@ori-events/virtual-page';

const pageTitle = 'simplified-registration';

const virtualPagePahNameMap = new Map<string, string>([
  ['ContactVerification', 'contact-verification'],
  ['PersonalInfoStep', 'personal-info'],
  ['SponsorSelectionStep', 'sponsor-selection'],
  ['LegalInformationStep', 'legal'],
  ['SubmitStep', 'registration-submited'],
]);

const getVirtualPagePathName = (virtualStep: string): string => {
  if (virtualPagePahNameMap.has(virtualStep)) {
    return virtualPagePahNameMap.get(virtualStep) as string;
  }

  return 'unknown-step';
};

const getVirtualPageURL = (urlBase: string, virtualStep: string, registrationId: string): string =>
  `${urlBase}/${getVirtualPagePathName(virtualStep)}?virtualStep=${virtualStep}&registrationId=${registrationId}`;

const getPageURL = (registrationId: string, step?: string): string => {
  const urlBase = window.location.origin + window.location.pathname;
  if (!step) {
    return urlBase + window.location.search;
  }

  return getVirtualPageURL(urlBase.replace(/\/+$/, ''), step, registrationId);
};

export const virtualPageEventDispatch = (
  currentStep: string | undefined,
  previousStep: string | undefined,
  registrationId: string,
): void => {
  const virtualPageEventData: VirtualPageEvent.Data = {
    virtualPageTitle: pageTitle,
    previousPageURL: getPageURL(registrationId, previousStep),
    virtualPageURL: getPageURL(registrationId, currentStep),
  };

  const event = new CustomEvent<VirtualPageEvent.Data>(VirtualPageEvent.Name, {
    detail: virtualPageEventData,
  });

  window.dispatchEvent(event);
};
